module.exports = __webpack_public_path__ + "img/CuCiTopi.08f45db6.png";